<template>
  <v-card>
    <v-toolbar color="#f44" dark>
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

      <v-toolbar-title>Profile Settings</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- <v-btn icon>
              <v-icon>more_vert</v-icon>
            </v-btn> -->
    </v-toolbar>

    <v-list>
      <router-link to="/profile">
        <v-list-tile class="t-center pointer">
          <v-list-tile-content>
            <div class="flex-space-between">
              <v-list-tile-title :class="active == 'general' && 'active'">
                General Information
              </v-list-tile-title>
              <v-icon :color="active == 'general' ? '#f44' : ''">
                chevron_right
              </v-icon>
            </div>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
      <router-link to="/profile/subscription">
        <v-list-tile class="t-center pointer">
          <v-list-tile-content>
            <div class="flex-space-between">
              <v-list-tile-title :class="active == 'subscription' && 'active'">
                Manage Subscription
              </v-list-tile-title>
              <v-icon :color="active == 'subscription' ? '#f44' : ''">
                chevron_right
              </v-icon>
            </div>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
      <router-link to="/profile/transaction">
        <v-list-tile class="t-center pointer">
          <v-list-tile-content>
            <div class="flex-space-between">
              <v-list-tile-title :class="active == 'transaction' && 'active'">
                Transactions
              </v-list-tile-title>
              <v-icon :color="active == 'transaction' ? '#f44' : ''">
                chevron_right
              </v-icon>
            </div>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
      <router-link to="/profile/password">
        <v-list-tile class="t-center pointer">
          <v-list-tile-content>
            <div class="flex-space-between">
              <v-list-tile-title :class="active == 'password' && 'active'">
                Change Password
              </v-list-tile-title>
              <v-icon :color="active == 'password' ? '#f44' : ''">
                chevron_right
              </v-icon>
            </div>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
      <!-- <v-list-tile class="t-center pointer">
        <v-list-tile-content>
          <div class="flex-space-between">
            <v-list-tile-title :class="active == 'emails' && 'active'">
              Emails
            </v-list-tile-title>
            <v-icon :color="active == 'emails' ? '#f44': ''">
              chevron_right
            </v-icon>
          </div>
        </v-list-tile-content>
      </v-list-tile> -->
    </v-list>
  </v-card>
</template>
<script>
  export default {
    props: ["active"],
  };
</script>
<style scoped>
  ::v-deep .v-list__group__header__append-icon {
    visibility: hidden !important;
  }
  .pointer {
    border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
  .pointer:first-child {
    border-top: 0;
  }
  .t-center .v-list__tile__title,
  .t-center .v-list__tile__content,
  .pl20 {
    padding-left: 2%;
  }
  .active {
    color: #f44;
    font-weight: 500;
  }
  .flex-space-between {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .pointer {
    cursor: pointer;
  }
  ::v-deep .v-list a {
    text-decoration: none;
    color: inherit;
  }
</style>
